import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  height: 100vh;

  main {
    padding: 18px 0;
  }

  .content-wrapper {
    position: relative;
    flex: 1;
    width: calc(100% - 270px);
    height: 100%;
    overflow-y: auto;
    background-color: rgb(249, 250, 252);
  }
`;
